import { isDev } from './env.helpers';

declare global {
	var USE_LOGGER: boolean;
}

globalThis.USE_LOGGER = isDev();

export function logger(...arg: unknown[]) {
	if (globalThis.USE_LOGGER) {
		console.log(...arg);
	}
}
